// extracted by css-extract-rspack-plugin
export default {"CommentBoxContainer":"ReviewMenuContent-module__CommentBoxContainer__hDeoQ"};